import { Project } from '../model/project/project';
import ProjectHelper from './project-helper';
import { SubProject } from '../model/project/sub-project';

export class SubProjectCount {
  public totalCount = new Map<string, number>();
  public subProjectIndex = new Map<number, number>();

  constructor(project?: Project, private readonly client = false) {
    if (project != null) {
      this.recalculate(project);
    }
  }

  public recalculate(project: Project): void {
    this.totalCount.clear();
    this.subProjectIndex.clear();
    if (project.subProjects == null || project.subProjects.length === 0) {
      return;
    }
    project.subProjects.forEach(sub => {
      if (sub.archived) {
        return;
      }
      if (sub.type != null) {
        let typeCount = this.totalCount.get(sub.type);
        if (typeCount == null) {
          typeCount = 0;
        }
        this.totalCount.set(sub.type, typeCount + 1);
      }
      if (sub.id != null) {
        this.subProjectIndex.set(
          sub.id,
          ProjectHelper.getDisplayIndexForSubProject(project, sub)
        );
      }
    });
  }

  public getTabTitleDisplay(
    subProject: SubProject,
    isIPBoardProject = false,
    oldPlatformId?: number
  ): string {
    let toReturn = ProjectHelper.getSubProjectTypeTitle(
      subProject,
      this.client,
      subProject.id != null,
      isIPBoardProject
    );
    if (
      subProject.id != null &&
      subProject.type != null &&
      (subProject.type === 'BaseProject' ||
        this.totalCount.get(subProject.type) > 1)
    ) {
      toReturn +=
        ' #' +
        this.subProjectIndex.get(subProject.id) +
        (oldPlatformId != null ? ` (#${oldPlatformId})` : '');
    }
    return toReturn;
  }
}
